// 수학 관련 유틸리티 함수들
class MathUtils {
  // 랜덤 숫자 생성 (min 이상 max 이하)
  static randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  // 랜덤 정수 생성 (min 이상 max 이하)
  static randomIntBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // 배열에서 랜덤 요소 선택
  static randomChoice(array) {
    return array[Math.floor(Math.random() * array.length)];
  }

  // 두 점 사이의 거리 계산
  static distance(pos1, pos2) {
    const dx = pos1.x - pos2.x;
    const dz = pos1.z - pos2.z;
    return Math.sqrt(dx * dx + dz * dz);
  }

  // 각도를 라디안으로 변환
  static degToRad(degrees) {
    return (degrees * Math.PI) / 180;
  }

  // 라디안을 각도로 변환
  static radToDeg(radians) {
    return (radians * 180) / Math.PI;
  }

  // 값을 범위 내로 제한
  static clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  // 선형 보간
  static lerp(start, end, factor) {
    return start + (end - start) * factor;
  }

  // 벡터 정규화
  static normalizeVector(vector) {
    const length = Math.sqrt(vector.x * vector.x + vector.z * vector.z);
    if (length === 0) return { x: 0, z: 0 };
    return {
      x: vector.x / length,
      z: vector.z / length,
    };
  }

  // 회전 차이를 -π ~ π 범위로 정규화
  static normalizeRotationDifference(difference) {
    while (difference > Math.PI) difference -= 2 * Math.PI;
    while (difference < -Math.PI) difference += 2 * Math.PI;
    return difference;
  }

  // 부드러운 회전 계산
  static smoothRotation(currentRotation, targetRotation, rotationSpeed = 0.1) {
    const rotationDifference = this.normalizeRotationDifference(
      targetRotation - currentRotation
    );
    return currentRotation + rotationDifference * rotationSpeed;
  }

  // 즉시 목표 회전으로 설정
  static immediateRotation(direction) {
    if (direction.length() > 0) {
      return Math.atan2(direction.x, direction.z);
    }
    return 0;
  }
}

// webpack 빌드를 위해 default export 추가
export default MathUtils;

// 전역 변수로도 등록 (기존 코드 호환성)
window.MathUtils = MathUtils;